import { render, staticRenderFns } from "./relatorioCadOrgao.vue?vue&type=template&id=518f250c"
import script from "./relatorioCadOrgao.vue?vue&type=script&lang=js"
export * from "./relatorioCadOrgao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports